import MaterialesCV from "./controladorVista/materialesCV"

export const Materiales = () => {
    return <MaterialesCV />;
}
